import { render, staticRenderFns } from "./FreezeCard.vue?vue&type=template&id=2ff9cfa2&"
import script from "./FreezeCard.vue?vue&type=script&lang=js&"
export * from "./FreezeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports